export default __webpack_public_path__ + "static/media/imgLightEn2.47e1d2cd.png";